module.exports = __webpack_public_path__ + "static/media/gearHigh.099bc7ee.png";